import { LOGGED_IN, LOGIN_FAILURE, LOGGED_OUT } from '../actions/auth';

const initialState = {
  isAuthenticated: false,
  error: null,
};

const authReducer = (state = initialState, action) => {
  switch (action.type) {
    case LOGGED_IN:
      return {
        ...state,
        isAuthenticated: true,
        error: null,
      };

    case LOGIN_FAILURE:
      return {
        ...state,
        isAuthenticated: false,
        error: action.payload,
      };

    case LOGGED_OUT:
      return initialState;

    default:
      return state;
  }
};

export default authReducer;
